<template>
    <div>
        <a-form :label-col="{ span: 8 }" :wrapper-col="{ span: 14 }" :colon="false" :form="form" @submit="handleSubmit">
            <a-row>
                <a-col :lg="12" :md="12" :sm="24">
                    <InputField style="width: 90%; margin: 0.5rem auto" label="编号" type="text" id="code"
                                :modelValue="form.code" placeholder="请输入编号" required
                                @update:modelValue="(value) => handleModelValueUpdate('code', value)"
                    />
                </a-col>
            </a-row>
            <a-row>
                <a-col :lg="12" :md="12" :sm="24">
                    <InputField style="width: 90%; margin: 0.5rem auto" label="起点位置" type="text" id="startLnglat" :disabled = "view === '修改管网'"
                                :modelValue="form.startLnglat" placeholder="请输入起点位置"
                                inputImg required @img-click="pasteLnglat('start')"
                                @update:modelValue="(value) => handleModelValueUpdate('startLnglat', value)"
                    />
                </a-col>

                <a-col :lg="12" :md="12" :sm="24">
                    <InputField style="width: 90%; margin: 0.5rem auto" label="起点井" type="text" id="pointFrom" :disabled = "view === '修改管网'"
                                :modelValue="form.pointFrom" placeholder="请输入起点井"
                                inputImg  @img-click="pasteWell('start')"
                                @update:modelValue="(value) => handleModelValueUpdate('pointFrom', value)"
                    />
                </a-col>

                <a-col :lg="12" :md="12" :sm="24">

                    <InputField style="width: 90%; margin: 0.5rem auto" label="终点位置" type="text" id="endLnglat" :disabled = "view === '修改管网'"
                                :modelValue="form.endLnglat" placeholder="请输入终点位置"
                                inputImg required="" @img-click="pasteLnglat('end')"
                                @update:modelValue="(value) => handleModelValueUpdate('endLnglat', value)"
                    />
                </a-col>

                <a-col :lg="12" :md="12" :sm="24">
                    <InputField style="width: 90%; margin: 0.5rem auto" label="终点井" type="text" id="pointTo" :disabled = "view === '修改管网'"
                                :modelValue="form.pointTo" placeholder="请输入终点井"
                                inputImg @img-click="pasteWell('end')"
                                @update:modelValue="(value) => handleModelValueUpdate('pointTo', value)"
                    />
                </a-col>

                <a-col :lg="12" :md="12" :sm="24">
                    <InputField style="width: 90%;margin:0.5rem auto" label="起点高程(m)" type="number" id="elevationFrom"
                                :modelValue="form.elevationFrom" placeholder="请输入起点高程(m)"
                                @update:modelValue="(value) => handleModelValueUpdate('elevationFrom', value)"
                    />
                </a-col>

                <a-col :lg="12" :md="12" :sm="24">
                    <InputField style="width: 90%;margin:0.5rem auto" label="终点高程(m)" type="number" id="elevationTo"
                                :modelValue="form.elevationTo" placeholder="请输入终点高程(m)"
                                @update:modelValue="(value) => handleModelValueUpdate('elevationTo', value)"
                    />
                </a-col>

                <a-col :lg="12" :md="12" :sm="24">
                    <InputField style="width: 90%;margin:0.5rem auto" label="起点埋深(m)" type="number" id="buringDepthFrom"
                                :modelValue="form.buringDepthFrom" placeholder="请输入起点埋深(m)"
                                @update:modelValue="(value) => handleModelValueUpdate('buringDepthFrom', value)"
                    />
                </a-col>

                <a-col :lg="12" :md="12" :sm="24">
                    <InputField style="width: 90%;margin:0.5rem auto" label="终点埋深(m)" type="number" id="buringDepthTo"
                                :modelValue="form.buringDepthTo" placeholder="请输入终点埋深(m)"
                                @update:modelValue="(value) => handleModelValueUpdate('buringDepthTo', value)"
                    />
                </a-col>

                <a-col :lg="12" :md="12" :sm="24">
                    <InputField style="width: 90%;margin:0.5rem auto" label="管长(m)" type="number" id="length"
                                :modelValue="form.length" placeholder="请输入管长(m)"
                                @update:modelValue="(value) => handleModelValueUpdate('length', value)"
                    />
                </a-col>

                <a-col :lg="12" :md="12" :sm="24">
                    <InputField style="width: 90%;margin:0.5rem auto" label="管径(mm)" type="number" id="diameter"
                                :modelValue="form.diameter" placeholder="请输入管径(mm)"
                                @update:modelValue="(value) => handleModelValueUpdate('diameter', value)"
                    />
                </a-col>

                <a-col :lg="12" :md="12" :sm="24">
                    <InputField style="width: 90%;margin:0.5rem auto" label="材质" type="text" id="material"
                                :modelValue="form.material" placeholder="请输入材质"
                                @update:modelValue="(value) => handleModelValueUpdate('material', value)"
                    />
                </a-col>

                <a-col :lg="12" :md="12" :sm="24">
                    <InputField style="width: 90%;margin:0.5rem auto" label="所在道路" type="text" id="location"
                                :modelValue="form.location" placeholder="请输入所在道路"
                                @update:modelValue="(value) => handleModelValueUpdate('location', value)"
                    />
                </a-col>
            </a-row>

            <div class="center" style="margin-top: 1rem;">
                <a-space>
                    <ButtonField text="关闭" @click="cancel" secondary />
                    <ButtonField text="保存" primary @click="handleSubmit"/>
                </a-space>
            </div>
        </a-form>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { modifyRain,fetchDetail } from "../api/pipe-info.js";

export default {
    data() {
        return {
            view: '修改检查井',
            wellTypes: [],
            detail: {},
            form: {
                category: null,
                type: null,
                code: null,
                lnglat: null,
                location: null,
                diameterCover: null,
                diameterRoom: null,
                elevation: null,
                materialCover: null,
                materialWell: null,
                shapeCover: null,
                depth: null,
            },
            pipeList: [],
            saveLoading: false,
        };
    },
    props: {
        id: {
            type: String,
            default: ''
        }
    },
    watch: {
        selectedWell: {
            handler() {
                if (this.view === "修改检查井" && this.selectedWell._edit) {
                    this.getDetail();
                }
            },
            deep: true,
        },
    },

    computed: {
        ...mapGetters("setting", ["findDataDict"]),
        rainWellTypes() {
            return this.findDataDict("rainWellType");
        },
        sewageWellTypes() {
            return this.findDataDict("sewageWellType");
        },
    },

    mounted() {
        this.getDetail();
    },

    methods: {
        getDetail() {
            fetchDetail({ id: this.id, type: 'rain' }).then((res) => {
                if (!res || !res.id) {
                    this.$message.error('未找到检查井信息');
                    return;
                }
                console.log("res::", res);
                this.form = { ...this.form, ...res };
                this.form.startLnglat = res.xfrom + "," + res.yfrom;
                // this.form.pointFrom = res.yfrom;
                this.form.endLnglat = res.xto + "," + res.yto;
                // this.form.pointTo = res.yto;
            }).catch((error) => {
                console.error("获取检查井信息失败", error);
                this.$message.error('获取检查井信息失败，请重试');
            });
        },
        handleModelValueUpdate(fieldName, value) {
            this.form[fieldName] = value;
        },
        pasteLnglat() {
            const { lng, lat } = this.selectedLnglat;
            if (!lng) {
                this.$message.error("请点击地图选择经纬度");
                return;
            }
            this.form.lnglat = lng + "," + lat
        },

        onCategoryChange(value) {
            this.form.type = undefined; // 重置 type 字段

            if (value === "sewage") {
                this.wellTypes = this.sewageWellTypes;
            } else {
                this.wellTypes = this.rainWellTypes;
            }
        },

        handleSubmit() {
            if (this.isSubmitting) return;
            this.isSubmitting = true;
            if (!this.form.code) {
                this.$message.error('编号不能为空');
                this.isSubmitting = false;
                return;
            }
            if (!this.form.x && !this.form.y) {
                this.$message.error('经纬度不能为空');
                this.isSubmitting = false;
                return;
            }

            this.saveLoading = true;
            modifyRain(this.form).then(() => {
                this.cancel();
            })
                .finally(() => {
                    this.saveLoading = false;
                });
        },

        cancel() {
            this.$emit('show-rain-index');
        },
    },
};
</script>

<style lang="less" scoped>
.location {
  display: block;
  height: auto;
  width: 12px;
}

.center {
  padding-bottom: 24px;
}
</style>
